import { PRODUCTS } from '../lib/constants/appConstants';

export const deductibleConfig = [
  {
    product: PRODUCTS.VILLA,
    dedutibleInfo: [
      {
        packageCode: 'VILLA_HOME_PACK_001',
        deductibleSelfRisk: '1 800 kr',
        deductibleBuilding: '2 000 kr'
      },
      {
        packageCode: 'VILLA_HOME_PACK_002',
        deductibleSelfRisk: '2 000 kr',
        deductibleBuilding: '2 000 kr'
      },
      {
        packageCode: 'VILLA_HOME_PACK_003',
        deductibleSelfRisk: '2 000 kr',
        deductibleBuilding: '4 000 kr'
      }
    ]
  }
];
